import actions from "./actions";

const {
    FETCH_RESULT_PUBLICATIONS,
    FETCH_RESULT_PUBLICATION,
    RESET_RESULT_PUBLICATION
} = actions;

const initState = {
    resultPublications: {
        page: 0,
        perPage: 35,
        data: [],
        total: 0
    },
    resultPublication: { _id: null }
};

const ResultPublicationReducer = (state = initState, action) => {
    const { type, data } = action;
    switch (type) {
        case FETCH_RESULT_PUBLICATIONS:
            return {
                ...state,
                resultPublications: data
            };
        case FETCH_RESULT_PUBLICATION:
            return {
                ...state,
                resultPublication: data
            };
        case RESET_RESULT_PUBLICATION:
            return {
                ...state,
                resultPublication: initState.resultPublication
            };
        default:
            return state;
    }
};

export default ResultPublicationReducer;